class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', async (event) => {
      event.preventDefault();
      const mainItemId = this.childNodes[1].getAttribute("data-variant-id");
      try {
        const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
        const cartData = await fetch('/cart.js').then(response => response.json());

        let mainItemIndex = this.dataset.index;
        if (mainItemIndex !== null) {
          const itemElement = this.closest('.cart-item');
          itemElement.classList.add('removing');
          await cartItems.updateQuantity(mainItemIndex, 0);
          let cartDrawer = qs('.drawer');
          let itemToRemoveIndex = null;
          cartData.items.forEach((item, index) => {
            if (item.properties && item.properties.bundle_id_installation && item.properties.bundle_id_installation == mainItemId) {
              itemToRemoveIndex = index + 1;
            }
          });

          if (itemToRemoveIndex !== null) {
            setTimeout(() => {
              cartItems.updateQuantity(itemToRemoveIndex, 0);
              cartDrawer.classList.add('animate', 'active');
            }, 500);
          }
        }
      } catch (error) {
        console.error('Error updating cart:', error);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);




class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });

    this.initializeQuotationControls();
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  initializeQuotationControls() {
    if (!qs(".download_quotation")) return;

    this.downloadQuotation();
    this.validateButton();
    this.getPdf();
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId, event.target.getAttribute('data-bundle-id'));
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
        console.log("If onCartUpdate");
        
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
        console.log("else onCartUpdate");
    }
  }




  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }


  updateQuantity(line, quantity, name, variantId, bundleId) {
    console.log("This Function updateQuantity Works.");
    
    this.enableLoading(line);
    this.quantityCheck();

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          // this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

        if (bundleId) {
          let bundleItem = qs(".disable-edits").getAttribute('data-bundle-item');
          let bundleItemId = qs(".disable-edits").getAttribute('data-bundle-id');
          const quantityDifference = quantity - qs(".disable-edits quantity-input input").value;
          if (qs(".cart-count")) {
            let cartCount = parseInt(qs(".cart-count").textContent.replace('(', '').replace(')', '')) + quantityDifference;
            qs(".cart-count").textContent = `(${cartCount})`;
            qs('.realtive_li.cart .cart-count-bubble span') && (qs('.realtive_li.cart .cart-count-bubble span').textContent = cartCount);
            qsa(".cart-count-bubble span").forEach((el) => {
              el.textContent = cartCount;
            });
          }

          document.querySelectorAll('.cart-item').forEach((cartItem, index) => {
            const quantityInput = cartItem.querySelector('.disable-edits .quantity__input');
            const totalPriceElement = cartItem.querySelector('.disable-edits .price.price--end');

            if (quantityInput && totalPriceElement && bundleId == cartItem.getAttribute('data-bundle-id')) {
              const unitPrice = parseFloat(quantityInput.getAttribute('data-unit-price') / 100);
              const newTotalPrice = (unitPrice * quantity).toFixed(2);

              totalPriceElement.innerHTML = `<span class="price price--end">
                AED ${newTotalPrice}
                <small class="tax_label">GST Incl</small>
              </span>`;
            }
          });

          if (quantityDifference > 0) {
            // Increase bundle item quantity
            const bundleBody = JSON.stringify({
              items: [{
                id: bundleItem,
                quantity: quantityDifference,
                properties: {
                  bundle_id_installation: bundleItemId
                }
              }]
            });

            fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body: bundleBody } })
              .then((response) => response.json())
              .then((bundleResponse) => {

              })
              .catch((error) => {
                console.error('Error adding bundle item:', error);
              });
          } else if (quantityDifference <= 0) {
            // Decrease bundle item quantity
            const bundleBody = JSON.stringify({
              id: bundleItem,
              quantity: quantity,
              properties: {
                bundle_id_installation: bundleItemId
              }
            });

            fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body: bundleBody } })
              .then((response) => response.json())
              .then((bundleResponse) => {

              })
              .catch((error) => {
                console.error('Error updating bundle item quantity:', error);
              });
          }
        }
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors)
          errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        this.slideShow();
        this.insertState();
        setTimeout(() => {
          let cartCountElem = qs('.cart-count');
          let cartContainer = qs('.realtive_li.cart');

          if (cartContainer) {
            if (cartCountElem) {
              let count = cartCountElem.textContent.replace(')', '').replace('(', '');
              cartContainer.innerHTML = `
                <a class="icons-links" id="cart-icon-bubble" role="button" aria-haspopup="dialog">
                  <svg class="icon icon-cart" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                    <path fill="currentColor" fill-rule="evenodd" d="m15.84,10.8l1.28-4.56H5.26l1.28,4.56c.08.29.25.54.48.71.22.17.51.27.81.27h6.73c.31,0,.59-.1.81-.27.22-.17.39-.41.48-.71h0Zm-1.29,2.57c.42,0,.8.17,1.08.45.28.28.45.66.45,1.08s-.17.8-.45,1.08c-.28.28-.66.45-1.08.45s-.8-.17-1.08-.45c-.28-.28-.45-.66-.45-1.08s.17-.8.45-1.08c.28-.28.66-.45,1.08-.45Zm.51,1.02c-.13-.13-.31-.21-.51-.21s-.38.08-.51.21c-.13.13-.21.31-.21.51s.08.38.21.51c.13.13.31.21.51.21s.38-.08.51-.21c.13-.13.21-.31.21-.51s-.08-.38-.21-.51Zm-7.24-1.02c.42,0,.8.17,1.08.45.28.28.45.66.45,1.08s-.17.8-.45,1.08c-.28.28-.66.45-1.08.45s-.8-.17-1.08-.45c-.28-.28-.45-.66-.45-1.08s.17-.8.45-1.08c.28-.28.66-.45,1.08-.45Zm.51,1.02c-.13-.13-.31-.21-.51-.21s-.38.08-.51.21c-.13.13-.21.31-.21.51s.08.38.21.51c.13.13.31.21.51.21s.38-.08.51-.21c.13-.13.21-.31.21-.51s-.08-.38-.21-.51ZM4.33,5.92l-.2-.73c-.08-.29-.25-.54-.48-.71-.22-.17-.51-.27-.81-.27h-1.31c-.22,0-.4-.18-.4-.4s.18-.4.4-.4h1.31c.49,0,.93.16,1.3.43.36.27.63.67.77,1.13l.13.46h12.62s.07,0,.11.02c.21.06.34.28.28.5l-1.42,5.07c-.13.47-.4.86-.77,1.13-.36.27-.81.43-1.3.43h-6.73c-.49,0-.93-.16-1.3-.43-.36-.27-.63-.66-.77-1.13l-1.42-5.04s-.01-.03-.01-.05h0Z"></path>
                  </svg>
                  <span class="visually-hidden">Cart</span>
                  <p class="cart-count-bubble">
                    <span aria-hidden="true">${count}</span>
                    <span class="visually-hidden">${count} item</span>
                  </p>
                </a>
                <p class="icon_para">CART</p>
              `;
            } else {
              cartContainer.innerHTML = `
                <a class="icons-links" id="cart-icon-bubble" role="button" aria-haspopup="dialog">
                  <svg class="icon icon-cart" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                    <path fill="currentColor" fill-rule="evenodd" d="m15.84,10.8l1.28-4.56H5.26l1.28,4.56c.08.29.25.54.48.71.22.17.51.27.81.27h6.73c.31,0,.59-.1.81-.27.22-.17.39-.41.48-.71h0Zm-1.29,2.57c.42,0,.8.17,1.08.45.28.28.45.66.45,1.08s-.17.8-.45,1.08c-.28.28-.66.45-1.08.45s-.8-.17-1.08-.45c-.28-.28-.45-.66-.45-1.08s.17-.8.45-1.08c.28-.28.66-.45,1.08-.45Zm.51,1.02c-.13-.13-.31-.21-.51-.21s-.38.08-.51.21c-.13.13-.21.31-.21.51s.08.38.21.51c.13.13.31.21.51.21s.38-.08.51-.21c.13-.13.21-.31.21-.51s-.08-.38-.21-.51Zm-7.24-1.02c.42,0,.8.17,1.08.45.28.28.45.66.45,1.08s-.17.8-.45,1.08c-.28.28-.66.45-1.08.45s-.8-.17-1.08-.45c-.28-.28-.45-.66-.45-1.08s.17-.8.45-1.08c.28-.28.66-.45,1.08-.45Zm.51,1.02c-.13-.13-.31-.21-.51-.21s-.38.08-.51.21c-.13.13-.21.31-.21.51s.08.38.21.51c.13.13.31.21.51.21s.38-.08.51-.21c.13-.13.21-.31.21-.51s-.08-.38-.21-.51ZM4.33,5.92l-.2-.73c-.08-.29-.25-.54-.48-.71-.22-.17-.51-.27-.81-.27h-1.31c-.22,0-.4-.18-.4-.4s.18-.4.4-.4h1.31c.49,0,.93.16,1.3.43.36.27.63.67.77,1.13l.13.46h12.62s.07,0,.11.02c.21.06.34.28.28.5l-1.42,5.07c-.13.47-.4.86-.77,1.13-.36.27-.81.43-1.3.43h-6.73c-.49,0-.93-.16-1.3-.43-.36-.27-.63-.66-.77-1.13l-1.42-5.04s-.01-.03-.01-.05h0Z"></path>
                  </svg>
                  <span class="visually-hidden">Cart</span>
                </a>
                <p class="icon_para">CART</p>
              `;
            }
          }
        }, 1000);
        this.dutyPopup();

        qs(".free-shipping") && this.updateFreeShipping();
        this.initializeQuotationControls();
        if (qs(".product-form__buttons quantity-input .quantity__input") && qs(".cart__empty-text")) {
          let currVarId = qs('.product-variant-id').value;
          window.variantId = currVarId;
          const stockNode = qs('.variant-inventory[data-variant-id="' + currVarId + '"]');
          if (!stockNode) return;
          let stoke = stockNode.textContent;
          qs(".product-form__buttons quantity-input .quantity__input").value = '1';
          if (stockNode.dataset.stockLimited === 'true') {
            qs(".product-form__buttons quantity-input .quantity__input").setAttribute("data-max", parseInt(stoke));
            qs(".product-form__buttons quantity-input .quantity__input").setAttribute("max", parseInt(stoke));
          } else {
            qs(".product-form__buttons quantity-input .quantity__input").removeAttribute("data-max");
            qs(".product-form__buttons quantity-input .quantity__input").removeAttribute("max");
          }
          qs(".product-form__buttons quantity-input .quantity__button[name='plus']").classList.remove('disabled');
          qs(".product-form__buttons quantity-input .quantity__button[name='plus']").classList.remove('not_Added_atc');
        }
      });
      
  }
  dutyPopup = () => {
    // Cookie reader
    const getCookie = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
      return null;
    };

    const stateName = getCookie("stateUAE") || 'United Arab Emirates';
    const checkoutBtn = qs(".static-checkout-btn"); // Popup trigger button
    const popup = qs(".duty-popup");
    const box = qs(".duty-box");
    const originalCheckoutBtn = qs(".original-checkout");

    if (!checkoutBtn || !popup || !box || !originalCheckoutBtn) return; // Safety check

    if (stateName === 'United Arab Emirates') {
      // Hide popup trigger, show direct checkout
      checkoutBtn.classList.add("hide");
      originalCheckoutBtn.classList.remove("hide");
    } else {
      // Hide direct checkout, show popup trigger
      originalCheckoutBtn.classList.add("hide");
      checkoutBtn.classList.remove("hide");

      checkoutBtn.addEventListener("click", () => {
        popup.classList.add("show");

        // Copy price into popup button
        const totalPriceEl = qs(".static-checkout-btn .total_price");
        const popupTotalPriceEl = qs(".duty-popup .cart__checkout-button .total_price");
        if (totalPriceEl && popupTotalPriceEl) {
          popupTotalPriceEl.textContent = totalPriceEl.textContent;
        }

        // Auto-click popup checkout after 6 seconds
        const popupCheckoutBtn = qs(".duty-popup .cart__checkout-button");
        if (popupCheckoutBtn) {
          setTimeout(() => popupCheckoutBtn.click(), 6000);
        }
      });

      // Close popup if click outside
      popup.addEventListener("click", (e) => {
        if (!box.contains(e.target)) {
          popup.classList.remove("show");
        }
      });
    }
  };
  quantityCheck = () => {
    const cartItems = document.querySelectorAll('[id^="CartDrawer-Item-"]');
    cartItems.forEach((item, index) => {
      const line = index + 1;
      const parent = `#CartDrawer-Item-${line}`;
      const selector = `#CartDrawer-Item-${line} .quantity__button[name='plus']`;
      const element = qs(parent);
      if (element.querySelector(".item-count-info")) {
        let limit = parseInt(element.querySelector(".item-count-info")?.getAttribute("data-qty-attr"));
        let quantity = element.querySelector('.quantity__input').value;
        if (limit != NaN && limit == quantity) {
          if (qs(selector)) {
            qs(selector).classList.add("not_Added");
          }
        }
        else {
          if (qs(".product-form__buttons quantity-input .quantity__input") && !qs(".product-form__submit").hasAttribute('disabled')) {
            qs(".product-form__buttons quantity-input .quantity__input").value = '1';
            qs(".product-form__buttons quantity-input .quantity__button[name='plus']").classList.remove('disabled');
          }
        }
      }
    });
  }

  downloadQuotation = () => {
    const openButton = qs(".download_quotation");
    const closeButton = qs(".show-shoping-screen");

    if (!openButton || !closeButton) return;

    const setQuotationView = (isOpen) => {
      const formBody = qs(".shoping-cart-form-body");
      const headQuote = qs(".head-quote");
      const deliveryCanvasScreen = qs(".delivery-canvas-screen");
      const quotation = qs(".quotation");
      const freeShipping = qs(".free-shipping");
      const cartDrawerItems = qs("cart-drawer-items");
      const cartWithFooter = qs(".cart-with-footer");
      const deliveryHeader = qs(".delivery-canvas-header-parent");
      const cartCtas = qs(".cart__ctas");

      formBody && formBody.classList.toggle('hide', !isOpen);
      formBody && formBody.classList.toggle('overflow-hidden', isOpen);
      headQuote && headQuote.classList.toggle('hide', !isOpen);
      deliveryCanvasScreen && deliveryCanvasScreen.classList.toggle('hide', isOpen);
      quotation && quotation.classList.toggle('hide', isOpen);
      freeShipping && freeShipping.classList.toggle('hide', isOpen);
      cartDrawerItems && cartDrawerItems.classList.toggle('hide', isOpen);
      cartWithFooter && cartWithFooter.classList.toggle('hide', isOpen);
      deliveryHeader && deliveryHeader.classList.toggle('hide', isOpen);
      cartCtas && cartCtas.classList.toggle('hide', isOpen);
      document.body.classList.toggle("overflow-hidden", isOpen);
    };

    openButton.onclick = (event) => {
      event.preventDefault();
      setQuotationView(true);
    };

    closeButton.onclick = (event) => {
      event.preventDefault();
      setQuotationView(false);
    };
  }

  validateButton = () => {
    const getValue = (selector) => {
      const el = document.querySelector(selector);
      if (!el || typeof el.value !== 'string') return '';
      return el.value.trim();
    };

    const downloadButton = document.querySelector('#download_book_Service1');
    if (downloadButton) downloadButton.disabled = true;

    const validateForm = () => {
      const full_name = getValue('#download_full_name1');
      const email = getValue('#download_email1');
      const isValidEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email);
      const button = document.querySelector('#download_book_Service1');
      if (button) button.disabled = !(full_name && isValidEmail);
    };

    validateForm();

    document.querySelectorAll('#download_full_name1, #download_email1').forEach((el) => {
      el.addEventListener('keyup', validateForm);
      el.addEventListener('change', validateForm);
    });
  }

  getPdf = () => {
    const getValue = (selector) => {
      const el = document.querySelector(selector);
      if (!el || typeof el.value !== 'string') return '';
      return el.value.trim();
    };

    const downloadButton = document.querySelector('#download_book_Service1');
    if (!downloadButton) return;

    if (downloadButton._quotationClick) {
      downloadButton.removeEventListener('click', downloadButton._quotationClick);
    }

    downloadButton._quotationClick = (e) => {
      e.preventDefault();

      const full_name = getValue('#download_full_name1');
      const email = getValue('#download_email1');
      const phone = getValue('#phone_number');
      const vat_number = getValue('#main_vat2');
      const company = getValue('#main_company1');
      const language = getValue('#download_language');

      let isValid = true;
      const showError = (selector, show) => {
        document.querySelectorAll(selector).forEach((el) => {
          el.style.display = show ? 'block' : 'none';
        });
      };

      if (!full_name) {
        isValid = false;
        showError('.full_name1', true);
      } else {
        showError('.full_name1', false);
      }

      if (!email) {
        isValid = false;
        showError('.email1', true);
      } else {
        showError('.email1', false);
      }

      if (!phone) {
        isValid = false;
        showError('.phone_number', true);
      } else {
        showError('.phone_number', false);
      }

      if (isValid) {
        downloadButton.disabled = true;
        downloadButton.textContent = 'Downloading...';
        document.querySelectorAll('.form-loading-overlay').forEach((el) => el.classList.add('showOverlay'));
        const cartUrl = `${(window.Shopify?.routes?.root || '/').replace(/\/$/, '')}/cart.js`;
        fetch(cartUrl)
          .then(response => response.json())
          .then(cartData => {
            const dataToPost = {
              name: full_name,
              phone: phone,
              email: email,
              vat: vat_number,
              company: company,
              language: language,
              cart: cartData
            };

            return fetch('https://orangered-oryx-187562.hostingersite.com/bguae/test.php', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify(dataToPost),
            });
          })
          .then(response => {
            if (!response.ok) {
              throw new Error(`Server error: ${response.status}`);
            }
            return response.text();
          })
          .then(text => {
            if (!text || text.trim() === '') {
              throw new Error('Server returned an empty response');
            }

            let data;

            try {
              data = JSON.parse(text);
            } catch (error) {
              console.error('Raw server response:', text);
              throw new Error('Invalid JSON from server: ' + text);
            }

            if (!data.url) {
              throw new Error('No URL returned from server');
            }

            console.log('Success:', data.url);
            window.open(`https://orangered-oryx-187562.hostingersite.com/bguae/test1.php?q=${encodeURIComponent(data.url)}`, '_blank');
            downloadButton.textContent = 'Downloaded';
            setTimeout(() => {
              downloadButton.disabled = false;
              downloadButton.textContent = 'DOWNLOAD QUOTATION';
            }, 2000);
          })
          .catch(error => {
            console.error('Error:', error.message);
            alert('Something went wrong: ' + error.message + '. Please try again.');
            downloadButton.disabled = false;
            downloadButton.textContent = 'DOWNLOAD QUOTATION';
          })
          .finally(() => {
            document.querySelectorAll('.form-loading-overlay').forEach((el) => el.classList.remove('showOverlay'));
          });
      }
    };

    downloadButton.addEventListener('click', downloadButton._quotationClick);
  }
  updateFreeShipping = () => {
    const eligibleAmt = parseInt(qs(".free-shipping").getAttribute("data-eligible-amt"));
    const cartTotal = parseInt(qs(".free-shipping").getAttribute("data-cart-total"));
    const difference = eligibleAmt - cartTotal;
    const progressBar = document.querySelector('.free-shipping-completed');

    if (cartTotal < eligibleAmt) {
      const percentage = (cartTotal / eligibleAmt) * 100;
      progressBar.style.width = `${percentage}%`;
      document.querySelector('.shipping.not-applied span').textContent = difference;
    } else {
      progressBar.style.width = '100%';
    }
  }

 insertState = async () => {
  const isArabic =
    document.documentElement.lang === "ar" ||
    document.documentElement.dir === "rtl";

  const TEXT = {
    indiaStore: isArabic
      ? `يرجى زيارة <a href="https://brewinggadgets.in/" target="_blank">متجر الهند</a>`
      : `Please visit our <a href="https://brewinggadgets.in/" target="_blank">India store</a>`,

    notShipping: (country) =>
      isArabic
        ? `نحن لا نقوم بالشحن إلى <strong>${country}</strong>.`
        : `We are not shipping in <strong>${country}</strong>.`,

    withinDays: (days) =>
      isArabic
        ? `خلال ${days} أيام عمل`
        : `within ${days} working days`,

    uaeNote: (days) =>
      isArabic
        ? `خلال ${days} أيام عمل (المنطقة الغربية 4 أيام عمل)`
        : `within ${days} working days (western region 4 working days)`
  };

  let dateInfo = getCookie("dateInfoUAE");
  let stateName = getCookie("stateUAE");

  const shippingCountries = {
    AE: "United Arab Emirates",
    OM: "Oman",
    SA: "Saudi Arabia",
    BH: "Bahrain",
    QA: "Qatar",
    JO: "Jordan",
    LB: "Lebanon",
    EG: "Egypt",
    KW: "Kuwait",
  };

  const shopper = window.getShopperCountry
    ? await window.getShopperCountry()
    : window.shopCountry;
  const countryIso = (shopper && shopper.iso) || "AE";
  const userCountry =
    (shopper && shopper.name) ||
    shippingCountries[countryIso] ||
    countryIso;

  /* ---------- BLOCK NON-ALLOWED COUNTRIES ---------- */
  if (
    !shippingCountries[countryIso] &&
    cn(dateInfo) &&
    cn(stateName)
  ) {
    if (qs(".product-deliver .append_country")) {
      qs(".product-deliver .append_country").innerHTML =
        countryIso === "IN"
          ? `<span class="diff-county">${TEXT.indiaStore}</span>`
          : `<span class="diff-county">${TEXT.notShipping(userCountry)}</span>`;
    }

    qs(".delivery-sub-header p .append_country")?.classList.add("hide");

    qsa(".shipping_change_value").forEach((radio) => (radio.checked = false));

    qs(".timing-courier")?.classList.add("hide");
    qs(".date_icons")?.classList.add("hide");

    this.changeState();
    this.changeLocationClick();
    return;
  }

  /* ---------- DEFAULT STATE ---------- */
  dateInfo =
    getCookie("dateInfoUAE") ||
    TEXT.uaeNote("02");

  stateName = getCookie("stateUAE") || "United Arab Emirates";

  const updateDateElements = (selector, text) => {
    qsa(selector).forEach((el) => (el.innerHTML = text));
  };

  if (dateInfo) {
    updateDateElements(".append_date", dateInfo);
  } else {
    let daysToAdd = "02";
    const selected = qs(".delivery-country-list-body input:checked");
    if (selected) daysToAdd = selected.getAttribute("data-date");

    let formattedDate =
      stateName === "United Arab Emirates"
        ? TEXT.uaeNote(daysToAdd)
        : TEXT.withinDays(daysToAdd);

    updateDateElements(".append_date", formattedDate);
  }

  qsa(".append_country").forEach((el) => (el.textContent = stateName));

  const shippingOption =
    qs(`.shipping_change_value[data-name="${stateName}"]`) ||
    qs(".shipping_change_value");

  if (shippingOption) shippingOption.checked = true;

  this.changeState();
  this.changeLocationClick();
};

/* ---------- CHANGE STATE ---------- */
changeState = () => {
  const isArabic =
    document.documentElement.lang === "ar" ||
    document.documentElement.dir === "rtl";

  const TEXT = {
    withinDays: (days) =>
      isArabic
        ? `خلال ${days} أيام عمل`
        : `within ${days} working days`,
    uaeNote: (days) =>
      isArabic
        ? `خلال ${days} أيام عمل (المنطقة الغربية 4 أيام عمل)`
        : `within ${days} working days (western region 4 working days)`
  };

  qsa(".shipping_change_value").forEach((radio) => {
    radio.addEventListener("change", function () {
      qs(".timing-courier")?.classList.remove("hide");
      qs(".date_icons")?.classList.remove("hide");
      qs(".delivery-sub-header p .append_country")?.classList.remove("hide");

      if (!this.checked) return;

      const state = this.value;
      setCookie("stateUAE", state);

      qsa(".append_country").forEach((el) => (el.textContent = state));

      let daysToAdd = "02";
      const selected = qs(".delivery-country-list-body input:checked");
      if (selected) daysToAdd = selected.getAttribute("data-date");

      let formattedDate =
        state === "United Arab Emirates"
          ? TEXT.uaeNote(daysToAdd)
          : TEXT.withinDays(daysToAdd);

      const checkoutBtn = qs(".static-checkout-btn");
      const originalCheckoutBtn = qs(".original-checkout");

      if (state === "United Arab Emirates") {
        checkoutBtn?.classList.add("hide");
        originalCheckoutBtn?.classList.remove("hide");
      } else {
        checkoutBtn?.classList.remove("hide");
        originalCheckoutBtn?.classList.add("hide");
      }

      setCookie("dateInfoUAE", formattedDate, 30);
      qsa(".append_date").forEach((el) => (el.innerHTML = formattedDate));

      qs(".delivery-country-list-body")?.classList.remove("active");
      qs(".cart__ctas")?.classList.remove("hide");
      qs(".ship-close") && (qs(".ship-close").style.display = "none");
      qs(".show-location-screen") &&
        (qs(".show-location-screen").style.display = "block");
      qs(".shop-cart-close")?.classList.remove("hide");
      qs(".drawer__inner")?.classList.remove("overflow-hidden");
    });
  });
};


  changeLocationClick = () => {
    let changeLocationButton = qs(".change-location");
    let changeLoc = qs(".show-location-screen");
    let cartDrawer = qs(".drawer");
    let deliveryBlock = qs(".delivery-country-list-body");
    if (changeLoc) {
      changeLoc.addEventListener("click", function () {
        qs(".shop-cart-close").classList.add("hide");
        qs(".drawer__inner").classList.add("overflow-hidden");
        deliveryBlock.classList.add("active");
        qs(".cart__ctas")?.classList.add("hide");
        document.body.classList.add("overflow-hidden");
        qs(".ship-close").style.display = "block";
        setTimeout(() => {
          cartDrawer.classList.add("animate", "active");
        });
        deliveryBlock.style.height = "100vh";
        qs(".ship-close").style.display = "block";
        qs(".show-location-screen") && (qs(".show-location-screen").style.display = "none");
        deliveryBlock.classList.add("active");
        const checkoutBtn = qs(".static-checkout-btn"); // Popup trigger button
        const popup = qs(".duty-popup");
        checkoutBtn.addEventListener("click", () => {
          popup.classList.add("show");
          const totalPriceEl = qs(".static-checkout-btn .total_price");
          const popupTotalPriceEl = qs(".duty-popup .cart__checkout-button .total_price");
          if (totalPriceEl && popupTotalPriceEl) {
            popupTotalPriceEl.textContent = totalPriceEl.textContent;
          }
          const popupCheckoutBtn = qs(".duty-popup .cart__checkout-button");
          if (popupCheckoutBtn) {
            setTimeout(() => popupCheckoutBtn.click(), 6000);
          }
        });
      });
    }
    if (changeLocationButton) {
      changeLocationButton.addEventListener("click", function () {
        if (qs(".cart__empty-text")) {
          qs('.unable-to-click') && qs('.unable-to-click').classList.remove('hide');
          return;
        }
        else {
          qs('.unable-to-click') && qs('.unable-to-click').classList.add('hide');
          if (deliveryBlock) {
            deliveryBlock.classList.add("active");
            qs(".cart__ctas")?.classList.add("hide");
            document.body.classList.add("overflow-hidden");
            qs(".drawer__inner").classList.add("overflow-hidden");
            deliveryBlock.style.height = "100%";
            qs(".show-location-screen") && (qs(".show-location-screen").style.display = "none");
            setTimeout(() => {
              cartDrawer.classList.add("animate", "active");
            });
          }
        }
      });
    }

    if (qs(".ship-close")) {
      qs(".ship-close").addEventListener(
        "click",
        function (event) {
          qs(".shop-cart-close").classList.remove("hide");
          qs(".drawer__inner").classList.remove("overflow-hidden");
          qs(".ship-close").style.display = "none";
          document.body.classList.remove("overflow-hidden");
          let deliveryBlock = qs(".delivery-country-list-body");
          deliveryBlock.classList.remove("active");
          qs(".cart__ctas")?.classList.remove("hide");
          changeLocationButton && (changeLocationButton.style.display = 'inline');
          qs(".show-location-screen") && (qs(".show-location-screen").style.display = 'block');
        }
      );
    }
  };

  slideShow = () => {
    document.querySelectorAll('cart-drawer slider-component').forEach((root) => {
      const slider = root.querySelector('[id^="Slider-"]');
      if (!slider) return;

      const bind = () => {
        if (root.initPages) root.initPages();
        if (root.dataset.cartSliderReady === 'true') return;
        root.dataset.cartSliderReady = 'true';
        slider.addEventListener('scroll', () => {
          const max = Math.max(0, slider.scrollWidth - slider.clientWidth);
          const next = root.querySelector('[name="next"]');
          const prev = root.querySelector('[name="previous"]');
          if (next && Math.abs(slider.scrollLeft) >= max - 2) next.setAttribute('disabled', 'disabled');
          if (prev && Math.abs(slider.scrollLeft) <= 2) prev.setAttribute('disabled', 'disabled');
        }, { passive: true });
      };

      if (window.customElements.get('slider-component')) bind();
      else window.customElements.whenDefined('slider-component').then(bind);
    });
  }
  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems && mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems && mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
  static __rqBound = false;

  requestedProduct = () => {
    if (CartItems.__rqBound) return;
    CartItems.__rqBound = true;

    const SELECTORS_CHECKOUT = [
      'button[name="checkout"]',
      '#CartDrawer-Checkout',
      '[data-action="checkout"]'
    ];

    const getCartForm = () =>
      document.getElementById('CartDrawer-Form') ||
      document.getElementById('Cart-Form') ||
      null;

    function isCheckoutTrigger(el) {
      if (!el) return false;
      if (el.classList && el.classList.contains('static-checkout-btn')) return false;
      if (el.classList && el.classList.contains('cart__checkout-button')) return true;
      if (el.name === 'checkout') return true;
      if (el.id && /CartDrawer-Checkout|checkout/i.test(el.id)) return true;
      if (el.getAttribute && el.getAttribute('data-action') === 'checkout') return true;
      return false;
    }

    // ---------- Quote detection ----------
    const QUOTE_TAGS = ['quote-only', 'request-product'];

    function isQuoteByProperty(item) {
      const p = item && item.properties ? item.properties : {};
      return (
        p._quote === '1' || p._quote === true ||
        p.quote === 'true' || p.quote === true ||
        p.show_only === '1' || p.show_only === true ||
        p['show-only'] === '1' || p['show-only'] === true
      );
    }

    async function hasQuoteTagForItem(item) {
      try {
        if (!item || !item.handle) return false;
        const res = await fetch(`/products/${encodeURIComponent(item.handle)}.js`, {
          headers: { 'Accept': 'application/json' },
          cache: 'no-store',
          credentials: 'same-origin'
        });
        if (!res.ok) return false;
        const product = await res.json();
        const raw = product && product.tags !== undefined ? product.tags : '';
        const tags = Array.isArray(raw)
          ? raw.map(t => String(t).trim().toLowerCase())
          : String(raw).split(',').map(t => t.trim().toLowerCase());
        return tags.some(t => QUOTE_TAGS.includes(t));
      } catch (_e) {
        return false;
      }
    }

    async function fetchCart() {
      const res = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' },
        cache: 'no-store',
        credentials: 'same-origin'
      });
      return res.ok ? res.json() : { items: [] };
    }

    async function getQuoteKeys() {
      const cart = await fetchCart();
      if (!cart || !Array.isArray(cart.items)) return [];
      const keys = [];
      for (const item of cart.items) {
        if (isQuoteByProperty(item)) {
          keys.push(item.key);
          continue;
        }
        if (await hasQuoteTagForItem(item)) {
          keys.push(item.key);
        }
      }
      return keys.filter(Boolean);
    }

    async function sleep(ms) {
      return new Promise(r => setTimeout(r, ms));
    }

    async function removeByKeys(keys) {
      for (const key of keys) {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }),
          cache: 'no-store',
          credentials: 'same-origin'
        });
        if (!res.ok) break;
        await sleep(130);
      }
      await fetchCart();
    }

    async function goOrWarn() {
      const cart = await fetchCart();
      const hasItems = !!(cart && Array.isArray(cart.items) && cart.items.length);
      if (!hasItems) {
        const err = document.getElementById('CartDrawer-CartErrors') ||
                    document.getElementById('cart-errors') ||
                    getCartForm();
        const msg = 'Only request for quote were in your cart. Add regular products to proceed to checkout.';
        if (err) {
          if (err.tagName === 'FORM') {
            let n = err.querySelector('.rq-cart-error');
            if (!n) {
              n = document.createElement('div');
              n.className = 'rq-cart-error';
              n.style.cssText = 'margin:8px 0;color:#b00020;font-size:14px;';
              err.prepend(n);
            }
            n.textContent = msg;
          } else {
            err.textContent = msg;
          }
        } else {
          alert(msg);
        }
        return false;
      }
      return true;
    }

    const setCheckoutDisabled = (disabled) => {
      document.querySelectorAll(SELECTORS_CHECKOUT.join(',')).forEach(b => {
        if (b) b.disabled = !!disabled;
      });
    };

    let busy = false;

    // Global CLICK guard
    document.addEventListener('click', async (e) => {
      const el = e.target && e.target.closest ? e.target.closest('button, a, input') : null;
      if (!isCheckoutTrigger(el)) return;

      e.preventDefault();
      if (busy) return;
      busy = true;

      try {
        const keys = await getQuoteKeys();
        if (keys.length) {
          setCheckoutDisabled(true);
          await removeByKeys(keys);
          if (!(await goOrWarn())) return;
        }
        window.location.href = '/checkout';
      } catch (err) {
        window.location.href = '/checkout';
      } finally {
        busy = false;
        setCheckoutDisabled(false);
      }
    }, { passive: false });

    // FORM SUBMIT guard
    document.addEventListener('submit', async (e) => {
      const form = e.target && e.target.closest ? e.target.closest('#CartDrawer-Form, #Cart-Form') : null;
      if (!form) return;

      const submitter = e.submitter || null;
      if (!isCheckoutTrigger(submitter)) return;

      e.preventDefault();
      if (busy) return;
      busy = true;

      try {
        const keys = await getQuoteKeys();
        if (keys.length) {
          setCheckoutDisabled(true);
          await removeByKeys(keys);
          if (!(await goOrWarn())) return;
        }
        form.submit();
      } finally {
        busy = false;
        setCheckoutDisabled(false);
      }
    });
  };


}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {
  const drawerEl = document.querySelector('cart-drawer-items');
  if (drawerEl && typeof drawerEl.requestedProduct === 'function') {
    drawerEl.requestedProduct();
  }
});

try {
  (window.__CartItemsInstance = window.__CartItemsInstance || new CartItems()).requestedProduct();
} catch (e) {
  console.error('CartItems requestedProduct init error:', e);
}

window.updateCartDrawer = async function updateCartDrawer({ open = true } = {}) {
  try {
    // 1) Pub/Sub if available (optional)
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'external' });
    }

    // 2) Fetch re-rendered sections
    const sections = ['cart-drawer', 'cart-icon-bubble'];
    const url = `${(window.routes && routes.cart_url) ? routes.cart_url : '/cart'}?sections=${sections.join(',')}`;
    const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    const data = await res.json();

    const parser = new DOMParser();

    // ---- Drawer swap (full section) ----
    if (data['cart-drawer']) {
      const doc = parser.parseFromString(data['cart-drawer'], 'text/html');
      const freshDrawerRoot = doc.querySelector('#CartDrawer');
      const liveDrawerRoot  = document.querySelector('#CartDrawer');
      if (freshDrawerRoot && liveDrawerRoot) liveDrawerRoot.replaceWith(freshDrawerRoot);
    }

    // ---- Bubble update (ANCHOR-PRESERVING) ----
    if (data['cart-icon-bubble']) {
      const doc = parser.parseFromString(data['cart-icon-bubble'], 'text/html');

      const liveAnchor   = document.querySelector('#cart-icon-bubble'); // your real header anchor
      const freshAnchor  = doc.querySelector('#cart-icon-bubble');      // some themes return anchor inside section
      const freshSection = doc.querySelector('#shopify-section-cart-icon-bubble') || doc.querySelector('.shopify-section');

      if (liveAnchor) {
        if (freshAnchor) {
          // Ideal case: replace anchor with new anchor (keeps href/role/etc. from the new template)
       	  liveAnchor.replaceWith(freshAnchor);
        } else if (freshSection) {
          // Section doesn't include <a>; just sync the count inside existing anchor
          const srcCountSpan = freshSection.querySelector('.cart-count-bubble span[aria-hidden="true"]');
          const srcVisSpan   = freshSection.querySelector('.cart-count-bubble .visually-hidden');

          const targetBubble = liveAnchor.querySelector('.cart-count-bubble') || (function(){
            // If bubble missing, create it so header stays consistent
            const div = document.createElement('div');
            div.className = 'cart-count-bubble';
            div.innerHTML = `<span aria-hidden="true">0</span><span class="visually-hidden">0 items</span>`;
            liveAnchor.appendChild(div);
            return div;
          })();

          if (srcCountSpan) {
            const countText = srcCountSpan.textContent.trim();
            const n = parseInt(countText, 10);

            // Update visible number
            const tgtHidden = targetBubble.querySelector('span[aria-hidden="true"]');
            if (tgtHidden) tgtHidden.textContent = countText;

            // Update screen-reader text
            const tgtVis = targetBubble.querySelector('.visually-hidden');
            if (tgtVis) tgtVis.textContent = srcVisSpan?.textContent?.trim() || (n === 1 ? '1 item' : `${n} items`);
          }
        } else {
          // Fallback: if nothing usable returned, do nothing to preserve anchor structure
        }
      } else {
        // No live anchor present -> fall back to replacing section wrapper if it exists on the page
        const liveSection = document.querySelector('#shopify-section-cart-icon-bubble') || document.querySelector('[data-section-id="cart-icon-bubble"]');
        if (freshSection && liveSection) liveSection.replaceWith(freshSection);
      }
    }

    // 3) Sync empty/non-empty flags using /cart.js (handles empty -> first item case)
    const cartState = await fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(r => r.json());
    const hasItems = (cartState.item_count || 0) > 0;

    const drawerEl = document.querySelector('cart-drawer');
    const innerEl  = drawerEl?.querySelector('.drawer__inner');
    const footerEl = document.querySelector('.cart-drawer__footer');
    if (drawerEl) drawerEl.classList.toggle('is-empty', !hasItems);
    if (innerEl)  innerEl.classList.toggle('is-empty', !hasItems);
    if (footerEl) footerEl.classList.toggle('is-empty', !hasItems);

    // 4) Re-bind header icon click to open drawer (because we may have swapped its node)
    if (drawerEl && typeof drawerEl.setHeaderCartIconAccessibility === 'function') {
      drawerEl.setHeaderCartIconAccessibility();
    } else {
      // Minimal fallback: click opens drawer
      const anchor = document.querySelector('#cart-icon-bubble');
      if (anchor) {
        anchor.addEventListener('click', (e) => {
          e.preventDefault();
          const d = document.querySelector('cart-drawer');
          if (d && typeof d.open === 'function') d.open(anchor);
        }, { once: true }); // avoid duplicate bindings across repeated refreshes
      }
    }

    // 5) Re-wire overlay close & re-init extras
    if (drawerEl) {
      const overlay = drawerEl.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', drawerEl.close?.bind(drawerEl), { once: true });

      drawerEl.slideShow && drawerEl.slideShow();
      drawerEl.insertState && drawerEl.insertState();
      drawerEl.dutyPopup && drawerEl.dutyPopup();
      if (drawerEl.querySelector('.free-shipping') && drawerEl.updateFreeShipping) drawerEl.updateFreeShipping();
      drawerEl.validateButton && drawerEl.validateButton();
      drawerEl.getPdf && drawerEl.getPdf();

      if (open && typeof drawerEl.open === 'function') drawerEl.open();
    }

    // 6) Nudge inner drawer list to stay in sync
    const drawerItems = document.querySelector('cart-drawer-items');
    if (drawerItems && typeof drawerItems.onCartUpdate === 'function') drawerItems.onCartUpdate();

    console.info('[updateCartDrawer] Drawer refreshed (anchor preserved).');
  } catch (err) {
    console.error('[updateCartDrawer] Failed:', err);
  }
};


